
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/students",
      function () {
        return require("private-next-pages/students.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/students"])
      });
    }
  